import TabsController from './component'

export default TabsController
